// extracted by mini-css-extract-plugin
module.exports = {"edit-changes-button":"EditChangesButton_edit-changes-button__1_AOg"};